export type StructureTypeName =
	| "genericWaterLevel"
	| "streamChannel"
	| "manhole"
	| "overflow"
	| "basin"
	| "snow"
	| "sdi12Multisensor"
	| "flapgate"
	| "genericWaterLevelPressure"
	| "genericWaterLevelDistance"
	| "sensorhiveOrbit3"
	| "waterQualitySensors"
	| "pipeOverflow"
	| "pipeOverflowAfterWeir"
	| "pipeBottomFlow"
	| "generic"
	| "genericOverflow"
	| "genericFlooding";

export type StructureTypeStyle = {
	label: string;
	bgColor: string;
	textColor: string;
	name: StructureTypeName;
};

export type StructureType = {
	[key in Dryp.StructureTypeId]: StructureTypeStyle;
};

export const structureType: StructureType = {
	["0" as Dryp.StructureTypeId]: {
		name: "genericWaterLevel",
		label: "Generic water level",
		bgColor: "#3B82F6",
		textColor: "#FFFFFF",
	},
	["1" as Dryp.StructureTypeId]: {
		name: "streamChannel",
		label: "Stream/Channel",
		bgColor: "#06B6D4",
		textColor: "#FFFFFF",
	},
	["2" as Dryp.StructureTypeId]: {
		name: "manhole",
		label: "Manhole",
		bgColor: "#6366F1",
		textColor: "#FFFFFF",
	},
	["3" as Dryp.StructureTypeId]: {
		name: "overflow",
		label: "Overflow",
		bgColor: "#F97316",
		textColor: "#FFFFFF",
	},
	["5" as Dryp.StructureTypeId]: {
		name: "basin",
		label: "Basin",
		bgColor: "#14B8A6",
		textColor: "#FFFFFF",
	},
	["6" as Dryp.StructureTypeId]: {
		name: "snow",
		label: "Snow",
		bgColor: "#38BDF8",
		textColor: "#FFFFFF",
	},
	["7" as Dryp.StructureTypeId]: {
		name: "sdi12Multisensor",
		label: "SDI-12 Multisensor",
		bgColor: "#FACC15",
		textColor: "#000000",
	},
	["8" as Dryp.StructureTypeId]: {
		name: "flapgate",
		label: "Flapgate",
		bgColor: "#FB923C",
		textColor: "#000000",
	},
	["9" as Dryp.StructureTypeId]: {
		name: "genericWaterLevelPressure",
		label: "Generic - Water Level (pressure)",
		bgColor: "#8B5CF6",
		textColor: "#FFFFFF",
	},
	["11" as Dryp.StructureTypeId]: {
		name: "genericWaterLevelDistance",
		label: "Generic - Water Level (distance)",
		bgColor: "#EC4899",
		textColor: "#FFFFFF",
	},
	["12" as Dryp.StructureTypeId]: {
		name: "sensorhiveOrbit3",
		label: "Sensorhive Orbit3",
		bgColor: "#D946EF",
		textColor: "#FFFFFF",
	},
	["13" as Dryp.StructureTypeId]: {
		name: "waterQualitySensors",
		label: "Water Quality Sensors",
		bgColor: "#84CC16",
		textColor: "#000000",
	},
	["14" as Dryp.StructureTypeId]: {
		name: "pipeOverflow",
		label: "PipeOverflow",
		bgColor: "#EF4444",
		textColor: "#FFFFFF",
	},
	["15" as Dryp.StructureTypeId]: {
		name: "pipeOverflowAfterWeir",
		label: "PipeOverflowAfterWeir",
		bgColor: "#F43F5E",
		textColor: "#FFFFFF",
	},
	["16" as Dryp.StructureTypeId]: {
		name: "pipeBottomFlow",
		label: "Pipe Bottom Flow",
		bgColor: "#2563EB",
		textColor: "#FFFFFF",
	},
	["999" as Dryp.StructureTypeId]: {
		name: "generic",
		label: "Generic",
		bgColor: "#94A3B8",
		textColor: "#FFFFFF",
	},
	["1000" as Dryp.StructureTypeId]: {
		name: "genericOverflow",
		label: "Generic - Overflow",
		bgColor: "#EAB308",
		textColor: "#000000",
	},
	["2000" as Dryp.StructureTypeId]: {
		name: "genericFlooding",
		label: "Generic - Flooding",
		bgColor: "#1D4ED8",
		textColor: "#FFFFFF",
	},
} satisfies StructureType;
